export class DadosIntegracaoModel {
    constructor(
        public nomeIntegrador: string = "",
        public cnpjIntegrador: string = "",
        public credencialCliente: string = "",
        public codigoAplicacao: number = 0
    ) { }
}